export const dashboardWidgets = {
  upcoming: {
    title: "عمليات الوصول القادمة",
    empty: "لا توجد أحداث قادمة",
    createBooking: "إنشاء حجز",
  },
  lastActivity: {
    title: "آخر نشاط",
  },
  portals: {
    title: "قنوات الحجز المتزامنة",
    connectedSuccess: "تم الاتصال بنجاح",
    unknownChannel: "غير معروف",
    connectNewChannel: "توصيل قناة جديدة",
    empty: "لا توجد قنوات متزامنة",
    connectChannel: "توصيل قناة",
    loadError: "تعذّر تحميل القنوات",
    errorTitle: "خطأ",
  },
};
